module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/status-bar/status-bar.component.css
// module id = ./src/app/components/status-bar/status-bar.component.css
// module chunks = main